let size = -1;

export function getScrollbarSize(recalculate?: boolean): number {
	if (size<0 || recalculate) {
		const div = document.createElement('div');
		const style = div.style;
		style.width = '100px';
		style.height = '100px';
		style.overflow = 'scroll';

		document.body.appendChild(div);
		size = div.offsetWidth - div.clientWidth;
		document.body.removeChild(div);
	}

	return size;
}
